var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-icon',{attrs:{"size":_vm.size,"icon":_vm.icon,"type":_vm.type,"icons":_vm.icons,"viewbox":_vm.viewbox,"width":_vm.width,"height":_vm.height}})}
var staticRenderFns = []

export { render, staticRenderFns }